import React from 'react'
import { useGlobalState } from '../../../../../hooks/store/useGlobalState'
import type { Practitioner as FHIRPractitioner } from '@teschglobal/tg-fhir-react-components/dist/types'
import { Practitioner } from '@teschglobal/tg-fhir-react-components'

type PractitionerDetailProps = {
  resource: FHIRPractitioner | null
  isFetching: boolean
}

const PractitionerDetail: React.FC<PractitionerDetailProps> = ({ resource }) => {
  const providerFromState = useGlobalState((state) => state.provider)

  const resolvedResource = resource ?? providerFromState ?? null

  if (!resolvedResource) {
    return (
      <div className="text-center" role="status" aria-live="polite" aria-atomic="true">
        Not Found
      </div>
    )
  }

  return (
    <section>
      <h3>Practitioner</h3>
      <Practitioner data={resolvedResource} />
    </section>
  )
}

export default PractitionerDetail
